<div>
    <app-car-card-list
        [businessLine]= businessLine!>

    </app-car-card-list>
</div>